define('SageDotCom/PatternAnimations/animatedSlickSlider',[
     "jquery",
     "ScrollMagic",
     "TweenMax",
     "AnimationPlugin"
],
    function (
         $,
         ScrollMagic,
         TweenMax,
         AnimationPlugin
    ) {
     function animatedSlickSlider() { }

     animatedSlickSlider.prototype.initialize = function () {
    

         // Slider Animation
         // checks if the slider component exists
         if ($(".score-slick-slider.slick-initialized, .slick-slider.slick-initialized").length) {
             // sets the animation trigger on the center of the viewport
             var controller = new ScrollMagic.Controller({
                 globalSceneOptions: {
                     triggerHook: 'onEnter'
                 }
             });

             // only slide-in if the viewport size is tablet or greater
             var viewPortWidth = $(window).width();
             if (viewPortWidth > 767) {
                 $(".slick-track").each(function () {

                     var tl = new TimelineMax();
                     var slider = $(this);
                     tl.from(slider, 0.5, {
                         repeat: 0,
                         left: 80,
                         opacity: 0
                     });

                     var scene = new ScrollMagic.Scene({
                         triggerElement: this,
                         triggerHook: 0.7
                     })
                         .setTween(tl)
                         .reverse(false)
                         .addTo(controller);
                 });
             }
         }
     };
     return new animatedSlickSlider();
});

